import { render } from "./HizliMusteri.vue?vue&type=template&id=4f183ee5"
import script from "./HizliMusteri.vue?vue&type=script&lang=js"
export * from "./HizliMusteri.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__